/**
 * Stand-ins for empty attributes in block previews (the block chooser's
 * thumbnails, `sample: true` in the block context). A block without sample
 * content would otherwise preview as an empty shell or a white rectangle.
 * Never used on the public site or in the editor.
 */

const TEXTS: Record<string, { heading: string; text: string; rich: string; link: string }> = {
  nl: { heading: "Voorbeeldtitel", text: "Tekst", rich: "<p>Dit is voorbeeldtekst. Zo ziet dit blok eruit zodra je eigen inhoud toevoegt.</p>", link: "Meer informatie" },
  en: { heading: "Example heading", text: "Text", rich: "<p>This is example text. This is how the block looks once you add your own content.</p>", link: "Learn more" },
  de: { heading: "Beispieltitel", text: "Text", rich: "<p>Dies ist Beispieltext. So sieht der Block aus, sobald Sie eigene Inhalte hinzufügen.</p>", link: "Mehr erfahren" },
};

export function previewText(locale: string) {
  return TEXTS[locale.slice(0, 2)] || TEXTS.en;
}

/** Soft landscape illustration (inline SVG, no request), 3:2 like most photo slots. */
export const PREVIEW_IMAGE = `data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">`
  + `<defs><linearGradient id="s" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#c7d2fe"/><stop offset="1" stop-color="#e0e7ff"/></linearGradient></defs>`
  + `<rect width="1200" height="800" fill="url(#s)"/><circle cx="900" cy="230" r="90" fill="#fef3c7"/>`
  + `<path d="M0 620 L300 380 L520 560 L760 330 L1200 680 V800 H0Z" fill="#a5b4fc"/>`
  + `<path d="M0 700 L380 520 L700 690 L1000 560 L1200 640 V800 H0Z" fill="#818cf8"/></svg>`,
)}`;

/** How many items an empty repeater shows in a preview. */
export const PREVIEW_REPEATER_ITEMS = 3;
